export const drawerClosedWidth = 56;
export const drawerWidth = 257;
export const pageSize = 100;
